import React from 'react'
import { connect } from 'react-redux'

import { shouldTrackGTM } from 'selectors/authSelectors'
import { getGoogleTagManagerId } from 'selectors/appStatusSelectors'

export const bootstrap = id => {
  ;(function(w, d, s, l, i) {
    w[l] = w[l] || []
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l !== 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.id = '__gtm'
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
    f.parentNode.insertBefore(j, f)
  })(window, document, 'script', 'dataLayer', id)
}

export class GoogleTagManager extends React.Component {
  componentDidMount() {
    let { shouldTrackGTM, gtmId } = this.props

    console.info('GTM Init', gtmId)

    if (gtmId && shouldTrackGTM) {
      bootstrap(gtmId)
    }
  }

  render() {
    return null
  }
}

function mapStateToProps(state, op) {
  let gtmId = getGoogleTagManagerId(state)

  return {
    ...op,
    gtmId,
    shouldTrackGTM: shouldTrackGTM(state),
  }
}

export default connect(mapStateToProps)(GoogleTagManager)

/*

Paste this code as high in the <head> of the page as possible:

<!-- Google Tag Manager -->
<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-PXB8575');</script>
<!-- End Google Tag Manager -->

Additionally, paste this code immediately after the opening <body> tag:

<!-- Google Tag Manager (noscript) -->
<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PXB8575"
height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
<!-- End Google Tag Manager (noscript) -->

  example noscript code NOT HOOKED UP

  <noscript>
    <iframe
      src="https://www.googletagmanager.com/ns.html?id=GTM-PXB8575"
      height="0"
      width="0"
      style="display:none;visibility:hidden">
    </iframe>
  </noscript>

*/
